/**
 * User-facing provenance vocabulary for results surfaces.
 * Prefer these over internal phrases like "backend result" or "engine".
 */
export const PROVENANCE_LABELS = {
	reported: "Lab / entered value",
	calculated: "Calculated by FlahaSOIL",
	modelEstimated: "Model estimate",
	classified: "Standard classification",
	interpreted: "Interpreted from your lab data",
	traceableOutput: "Traceable output",
} as const;

/** Short chip labels used on section headers. */
export const PROVENANCE_CHIP = {
	reported: "Reported",
	calculated: "Calculated",
	modelEstimated: "Model estimate",
	classified: "Classified",
	interpreted: "Interpreted",
	reportedInputsOnly: "Reported inputs only",
	unavailable: "Unavailable",
} as const;
